export {default as impactLogo} from './impactLogo.png';
export {default as inventoryLogo} from './inventoryLogo.png';
export {default as clipboardCheck} from './clipboardCheck.png';